/* eslint-disable no-undef */
import React, { useEffect }  from 'react'

import '../App.css'

const Player = () => {

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const hid = urlParams.get('hid');
    const cid = urlParams.get('cid');

    // const url = `https://live.univertech.cn/rtc/v1/whip-play/?app=live&stream=${hid}_${cid}`;
    const player = TCPlayer('player-container-id', {
      sources: [{
        src: `webrtc://pull.univertech.cn/live/${hid}_${cid}`,
      }]
    });
    player.src(`webrtc://pull.univertech.cn/live/${hid}_${cid}`);
  }, [])

  return (
    <div className="video-container">
      <video id="player-container-id" width="414" height="270" preload="auto" playsInline webkit-playsinline="true" x5-playsinline="true" />
    </div>
  )
}

export default Player;